import React, { createContext, useReducer, useState } from 'react'

import { fetch_help_articles, fetch_help_categories } from '../../services/help'
import { GET_HELP_ARTICLES, GET_HELP_CATEGORIES } from '../types'
import { sortArrayOfObjects } from '../../utils'

import reducer from './helpReducer'

export const HelpContext = createContext()

const HelpState = ({ children }) => {
  const initialState = {
    articles: {},
    articlesArr: [],
    whatsNewArticles: [],
    documentationArticles: [],
    articlesFetched: false,
    categories: {},
    categoriesArr: [],
    categoriesFetched: false,
  }

  const [selectedCategory, setSelectedCategory] = useState(null)
  const [state, dispatch] = useReducer(reducer, initialState)

  // Fetch articles
  const fetchHelpArticles = async () => {
    try {
      const res = await fetch_help_articles()
      let arr = []
      let whatsNewArr = []
      let documentationArr = []
      for(let id in res) {
        if(res[id].category === 'whats_new') {
          whatsNewArr.push({ id, ...res[id] })
        }else if(res[id].category === 'documentation'){
          documentationArr.push({ id, ...res[id] })
        }else {
          arr.push({ id, ...res[id] })
        }
      }
      dispatch({
        type: GET_HELP_ARTICLES,
        payload: {
          obj: res,
          arr: sortArrayOfObjects(arr, 'title.en', 'desc'),
          whatsNewArr: sortArrayOfObjects(whatsNewArr, 'title.en', 'desc'),
          documentationArr: sortArrayOfObjects(documentationArr, 'title.en', 'desc')
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  // Fetch help categories
  const fetchHelpCategories = async () => {
    try {
      const res = await fetch_help_categories()
      let arr = []
      for(let id in res) {
        if(id !== 'whats_new' && id !== 'documentation') {
          arr.push({ id, ...res[id] })
        }
      }
      dispatch({
        type: GET_HELP_CATEGORIES,
        payload: {
          obj: res,
          arr
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  return <HelpContext.Provider value={{
    articles: state.articles,
    articlesArr: state.articlesArr,
    whatsNewArticles: state.whatsNewArticles,
    documentationArticles: state.documentationArticles,
    articlesFetched: state.articlesFetched,
    categories: state.categories,
    categoriesArr: state.categoriesArr,
    categoriesFetched: state.categoriesFetched,
    fetchHelpArticles,
    fetchHelpCategories,
    selectedCategory,
    setSelectedCategory,
  }}>
    { children }
  </HelpContext.Provider>
}

export default HelpState